import React, { Component } from "react";
import Helmet from "react-helmet";
import RealsyncFeatures from "./features/RealsyncFeatures";
import { Container, Row, Col } from "reactstrap";

import "./index.scss";

class RealsyncPage extends Component {
  render() {
    return (
      <div className="realtask-container">
        <Helmet title={`Datasert - Appsuite`} />
        <br />
        <div className="main">
          <Container>
            <Row>
              <Col className="main-left">
                <h2>Realsync</h2>
                <h5>Near realsync data sync for Salesforce</h5>
                <p>
                  <a href="/company/contact">Contact Us</a> to try this out
                </p>
              </Col>
              <Col>
                <img
                  className="banner-image"
                  src={require("./images/realsync-overview.png")}
                />
              </Col>
            </Row>
          </Container>
        </div>

        <br />
        <br />
        <div className="features">
          <RealsyncFeatures />
        </div>
      </div>
    );
  }
}

export default RealsyncPage;



// WEBPACK FOOTER //
// ./src/pages/products/realsync/index.jsx